const steps = [
  {
    selector: '[campaigndetail-tour="edit"]',
    content: "Click here to edit camaign"
  },
  {
    selector: '[campaigndetail-tour="add-project"]',
    content: "Click here to add projects or to cancel the campaign"
  },
  {
    selector: '[campaigndetail-tour="reviewer-tab"]',
    content: "From the Reviewers tab you can track the progress of how the content is being reviewed. Make sure to check it out later!"
  },
  {
    selector: '[campaigndetail-tour="task-tab"]',
    content: "And you can find complete list of projects, tasks and assets in the respective tabs"
  },
          
];

export default steps;




